// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';
import ResponsiveImage from '../../internal/ResponsiveImage';
import PageContentBlock from '../../internal/PageContentBlock';

const variantMap = {
  Default: 'Thin',
  Wide: 'Default',
};

type PropTypes = {|
  image: string,
  alt: string,
  caption?: string,
  background: 'Default' | 'Dark',
  variant: 'Default' | 'Wide',
|};

const Image = (props: PropTypes) => {
  return (
    <PageContentBlock layout={variantMap[props.variant]} background={props.background}>
      <div className={cx(props.variant === 'Wide' && styles.isLarge)}>
        <ResponsiveImage
          className={styles.image}
          src={props.image}
          alt={props.alt}
          defaultSize={{ width: 780 }}
          srcSet={[{ mediaMaxWidth: 1000, width: 500 }, { mediaMaxWidth: 600, width: 300 }]}
        />
        {props.caption && (
          <p className={cx(styles.imageCaption, props.background === 'Dark' && styles.isDark)}>
            {props.caption}
          </p>
        )}
      </div>
    </PageContentBlock>
  );
};

Image.defaultProps = {
  background: 'Default',
  variant: 'Default',
};

export default Image;
